import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Tag } from '@/components'
import { JobsReponse } from '@/types/Job'
import { formatDate, getJobStartTime, parseDate } from '@/util'
import { isJobClaimed } from '@/util/JobUtil'

type Props = {
  job: JobsReponse
}

const MobileJobCard = ({ job }: Props) => {
  const navigate = useNavigate()

  const routeToJob = (jobId) => {
    navigate(`/jobs/${jobId}`)
  }
  return (
    <div
      className="mb-4 w-full overflow-hidden rounded-md border border-border-primary p-4 shadow-md"
      onClick={() => routeToJob(job?.id)}
      role={'presentation'}
    >
      <div className="mb-3 flex items-center justify-between">
        <p className="text-sm" style={{ fontWeight: 'bold' }}>
          {job?.jobTemplate?.name || ' '}
        </p>
      </div>
      <div className="mb-2 flex">
        <Tag className="mr-2 p-2 py-1 text-p-xs" variant={isJobClaimed(job) ? 'success' : 'warning'}>
          {isJobClaimed(job) ? 'Claimed' : 'Unclaimed'}
        </Tag>
        {job?.completed && (
          <Tag className="mr-2 p-2 py-1 text-p-xs" variant="success">
            Completed
          </Tag>
        )}
        {!!job?.cancelledAt && <Tag className="mr-2 p-2 py-1 text-p-xs">Cancelled</Tag>}
      </div>
      <div className="mb-2 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Home</p>
        <p className="ml-3 flex-1 text-right text-sm">{job?.home?.searchDocument}</p>
      </div>
      <div className="mb-2 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Schedule Date </p>
        <p className="ml-3 flex-1 text-right text-sm">{formatDate(parseDate(job?.startsAt), 'MM/dd/yyyy')}</p>
      </div>
      <div className="mb-2 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Starts At</p>
        <p className="ml-3 flex-1 text-right text-sm">{getJobStartTime(job?.startsAt, job?.market?.timezone)}</p>
      </div>
    </div>
  )
}

export default MobileJobCard
